import React from 'react';
import PropTypes from 'prop-types';
import Slider from "components/Slider";
import ShelfProduct from "components/ShelfProduct";
import ShelfProductLoader from "components/Home/ShelfProductLoader";
import ShelfProductV2 from "components/ShelfProductV2";
import style from './style.scss';//NOSONAR

const SliderProducts = (props) => {
    let products = props.products;
    const notPDP = props.notPDP;
    let productShelfNew = props.newProductShelf;

    const gtmData = (prod) => {
        if (prod && prod.item) {
            return {
                name: prod.productName,
                id: prod.item.itemId,
                refId: prod.item.skuData.ref_id,
                price: prod.item.prices.regular,
                brand: prod.brand,
                category: prod.categories ? prod.categories[0] : null,
                variant: '',
                list: props.listTitle,
                position: prod.pos,
                type: 'sliderProductsBanner',
            }
        }
    }

    const loader = () => {
        let loaders = []
        for(let i = 0; i < 4; i++){
            loaders.push(<ShelfProductLoader key={i} />);
        }
        return loaders;
    }
    const ShelfProductComponent = productShelfNew ? ShelfProductV2 : ShelfProduct;
    return (
        <div className="product-slide">
            {props.isLoading && loader()}
            {!props.isLoading && props.title && (
                <div className="product-slider-title">{props.title}</div>
            )}

            {!props.isLoading && (products && products.length > 1) && (<Slider arrows={true} className="product-slider-wrap">
                {products.map((product) => (
                    <ShelfProductComponent
                        product={product}
                        notPDP={notPDP}
                        key={product.productId}
                        position={product.pos}
                        limitTitle={productShelfNew ? 27 : 49}
                        listTitle={ props.listTitle || props.title || 'Products-Banner-Slider'}
                        gtmData={gtmData(product)}
                    />
                ))}
            </Slider>)}
        </div>
    )
};

SliderProducts.propTypes = {
    title: PropTypes.string,
    listTitle: PropTypes.string,
    productOptions: PropTypes.object,
    isLoading: PropTypes.bool,
    products: PropTypes.array,
    notPDP: PropTypes.bool,
    newProductShelf: PropTypes.bool
};

export default SliderProducts;
